import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';
import { AxiosError } from 'axios';
import { fetchCommonEventData } from 'api/events';
import { fetchEventExhibitors } from 'api/exhibitors';
import {
  EventStandardContainer,
  EventStandardContainerData,
} from 'components/EventStandardContainer';
import { ExhibitorsList } from 'containers/ExhibitorsList';
import { handleAxiosError, IError } from 'utils/handleAxiosError';

export type PageProps = InferGetStaticPropsType<typeof getStaticProps>;

const Exhibitors: NextPage<PageProps> = ({ data, error }) => (
  <EventStandardContainer
    data={data}
    error={error}
    Component={ExhibitorsList}
    pageName="Exhibitors"
  />
);

export const getStaticProps: GetStaticProps<
  {
    data?: EventStandardContainerData<ResolvedPromise<ReturnType<typeof fetchEventExhibitors>>>;
    error?: IError;
  },
  { eventId: string; page: string }
> = async ctx => {
  try {
    const eventId = ctx.params?.eventId as string;
    const page = Number(ctx.params?.page);

    const [{ eventInfo, tabsConfig }, data] = await Promise.all([
      fetchCommonEventData(eventId),
      fetchEventExhibitors({ eventId, page }),
    ]);

    return {
      props: {
        data: {
          ...eventInfo,
          tabsConfig,
          ...data,
        },
      },
      revalidate: 60,
    };
  } catch (err) {
    const error = handleAxiosError(err as AxiosError);

    return {
      props: { error },
      revalidate: 60,
    };
  }
};

export const getStaticPaths: GetStaticPaths = async () => ({ paths: [], fallback: 'blocking' });

export default Exhibitors;
